// @flow

export { default as ProfileCardNarrow } from './profile-narrow/ProfileCardNarrow';
export { default as ProfileCardWide } from './profile-wide/ProfileCardWide';
export { default as ProfileCardResponsive } from './ProfileCardResponsive';
export type { Profile } from './types';
